const DEFAULT_TIMEZONE = 'Europe/Vilnius';

export default DEFAULT_TIMEZONE;
